if (!customElements.get('device-qty-selector')) {
  customElements.define(
    'device-qty-selector',
    class DeviceQtySelector extends HTMLElement {
      constructor() {
        super();
        this.options = Array.from(this.querySelectorAll('.device-qty__option'));
        this.options.forEach((opt) => {
          opt.addEventListener('click', (e) => {
            e.preventDefault();
            this.select(opt);
          });
        });
      }

      connectedCallback() {
        const initial = this.options.find((o) => o.classList.contains('is-selected')) || this.options[0];
        if (initial) this.applyOption(initial, { silent: true });
      }

      select(option) {
        if (!option || option.classList.contains('is-selected')) return;
        this.applyOption(option);
      }

      applyOption(option, { silent = false } = {}) {
        this.options.forEach((o) => {
          const selected = o === option;
          o.classList.toggle('is-selected', selected);
          o.setAttribute('aria-checked', selected ? 'true' : 'false');
        });

        // Slot variant IDs (1 or 2 of them) and the pre-multiplier total
        // (in cents, with extra-discount % already baked in by Liquid).
        // band-upsell.js reads these to update the button price and to
        // inject the right items[] on form submit.
        this.dataset.activeVariants = option.dataset.variants || '';
        this.dataset.activeTotalCents = option.dataset.totalCents || '0';

        this.dispatchEvent(
          new CustomEvent('device-qty:change', {
            bubbles: true,
            detail: {
              variants: this.dataset.activeVariants.split(',').filter(Boolean).map(pair => {
                const [id, qty] = pair.split(':');
                return { id, qty: parseInt(qty, 10) || 1 };
              }),
              totalCents: parseInt(this.dataset.activeTotalCents, 10) || 0,
            },
          })
        );
      }
    }
  );
}
